export default __webpack_public_path__ + "static/media/Vector1.abb733a8.png";